module.exports = __webpack_public_path__ + "static/media/bitcoin.2e9f0bd6.webm";